(function() {
    'use strict';

    angular
        .module('editorApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('commodity', {
                parent: 'account',
                url: '/{storeId}/commodity',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.entities.commodity-center'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commodity/commodity.html',
                        controller: 'CommodityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }]
                }
            })

            .state('commoditySelect', {
                parent: 'account',
                url: '/{storeId}/{pid}/{vid}/{aid}/commoditySelect',
                data: {
                    authorities: [],
                    pageTitle: 'commodity.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commodity/commodity-select.html',
                        controller: 'CommoditySelectController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commodityPage');
                        $translatePartialLoader.addPart('common');
                        return $translate.refresh();
                    }],
                    // entity: ['$stateParams', 'Product', function ($stateParams, Product) {
                    //     return Product.get({id: $stateParams.pid}).$promise;
                    // }]
                }
            })
        ;
    }
})();
